// The text of a refused call: the one of its errorCode under `group` (fr.js,
// en.js), the group's generic one otherwise. The api's message is never shown.
export const apiErrorText = (text, group, error) => {
  const code = error?.response?.data?.errorCode;
  return (code && text(`${group}.${code}`)) || text(`${group}.generic`);
};

export const errorCodeOf = (error) => error?.response?.data?.errorCode ?? null;
